import { render } from "./ArchivedProjectsListView.vue?vue&type=template&id=f37c1602"
import script from "./ArchivedProjectsListView.vue?vue&type=script&lang=js"
export * from "./ArchivedProjectsListView.vue?vue&type=script&lang=js"

import "./ArchivedProjectsListView.vue?vue&type=style&index=0&id=f37c1602&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__